import { render, staticRenderFns } from "./TeamMembers.vue?vue&type=template&id=3f974094&"
import script from "./TeamMembers.vue?vue&type=script&lang=js&"
export * from "./TeamMembers.vue?vue&type=script&lang=js&"
import style0 from "./TeamMembers.vue?vue&type=style&index=0&id=3f974094&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow})
